import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PropTypes as MicromagPropTypes } from '@micromag/core';

import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { useUrlGenerator } from '@micromag/core/contexts';
import { Button } from '@micromag/core/components';
// import TeamMembers from '../partials/TeamMembers';
// import ThemeMenu from '../menus/Theme';

const propTypes = {
    theme: MicromagPropTypes.story.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ThemeMenubar = ({ theme, className }) => {
    const url = useUrlGenerator();
    return (
        <div
            className={classNames([
                'd-flex',
                'align-items-center',
                'justify-content-end',
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Button
                href={url('themes.settings', {
                    theme: theme.id,
                })}
                theme="secondary"
                outline
                className="ms-2"
                icon={<FontAwesomeIcon icon={faCog} color="currentColor" />}
            >
                <FormattedMessage defaultMessage="Settings" description="Button label" />
            </Button>
        </div>
    );
};

ThemeMenubar.propTypes = propTypes;
ThemeMenubar.defaultProps = defaultProps;

export default ThemeMenubar;
